$.TemplateSupport = {
  SearchProduct: (language) => {
    // let list = $('#productSearchModal .list-group');
    // list.empty();
    // $('#productSearchModal #noRecordsFound').removeClass('d-block').addClass('d-none');

    const searchResult = $('#supportProducts');
    const searchResultTable = $('#supportProducts table tbody');
    const searchButtonCaption = searchResult.data('button');
    const notFoundCaption = searchResult.data('not-found');

    searchResult.hide();
    searchResultTable.empty();
    $('#supportProduct').hide();

    const search = $('#supportSearchInput').val();
    if (search.trim() === '')
      return;

    const res = $.Backend.SearchProduct(search, language, true);
    res.then(function (response) {
      const data = response.data;
      if (data.products) {
        if (data.products.length === 0) {
          searchResultTable.append(`<tr><td class="align-middle">${notFoundCaption}</td></tr>`);
        } else {
          for (let p of data.products) {
            searchResultTable.append(`
              <tr>
                <td class="align-middle">${p.name}</td>                  
                <td class="align-middle text-end">
                  <span class="me-3">#${p.partNumber}</span>
                  <button class="btn btn-vb-primary-outline btn-small" onClick="javascript:$.TemplateSupport.SelectProduct(${language}, ${p.partNumber})">${searchButtonCaption}</a>
                </td>
              </tr>
            `);
          }
        }
        $('#supportProducts').show();
      } else if (data.product)
        $.TemplateSupport.ShowProductDocuments(data.product);
    });
  },

  SelectProduct: (language, pn) => {
    $('#supportProducts').hide();
    $('#supportSearchInput').val(pn);
    const res = $.Backend.SearchProduct(pn, language, true);
    res.then(function (response) {
      const data = response.data;
      $.TemplateSupport.ShowProductDocuments(data.product);
    });
  },

  ShowProductDocuments: (product) => {
    $('#supportProduct').hide();
    $('#supportProduct li').show();

    const supportProduct = $('#supportProduct');
    const downloadButtonCaption = supportProduct.data('button');

    $('#supportProduct h4').text(`${product.name} (#${product.partNumber}):`);
    $('#supportProduct .noItemFound').hide();
    $('#supportProduct ul').show();
    $('#supportProduct .tab-content').show();
    $('#SupportTabFirmwarePane table tbody').empty();
    $('#SupportTabManualsPane table tbody').empty();
    $('#SupportTabFAQsPane .accordion').empty();

    let activatedTab = false;
    let tab;

    if (product.firmware.length === 0 && product.manuals.length === 0 && product.faqs.length === 0) {
      $('#supportProduct .noItemFound').show();
      $('#supportProduct ul').hide();
      $('#supportProduct .tab-content').hide();
    } else {
      if (product.firmware.length === 0) {
        $('#SupportTabFirmware').hide();
      } else {
        tab = $('#SupportTabFirmware');
        tab.show();
        tab.click();
        activatedTab = true;

        for (let file of product.firmware) {
          $('#SupportTabFirmwarePane table tbody').append(`
            <tr>
              <td class="align-middle">${file.name}</td>
              <td class="align-middle">${file.description}</td>
              <td class="align-middle">${file.mime}</td>
              <td class="align-middle">${file.size}</td>
              <td class="align-middle text-center">
                <a href="${file.file}" class="btn btn-vb-primary-outline btn-small">${downloadButtonCaption}</a>
              </td>
            </tr>
          `);
        }
      }

      if (product.manuals.length === 0) {
        $('#SupportTabManuals').hide();
      } else {
        tab = $('#SupportTabManuals');
        tab.show();
        if (!activatedTab) {
          tab.click();
          activatedTab = true;
        }

        for (let file of product.manuals) {
          $('#SupportTabManualsPane table tbody').append(`
            <tr>
              <td class="align-middle">${file.name}</td>
              <td class="align-middle">${file.description}</td>
              <td class="align-middle">${file.mime}</td>
              <td class="align-middle">${file.size}</td>
              <td class="align-middle text-center">
                <a href="${file.file}" class="btn btn-vb-primary-outline btn-small">${downloadButtonCaption}</a>
              </td>
            </tr>
          `);
        }
      }

      if (product.faqs.length === 0) {
        $('#SupportTabFAQs').hide();
      } else {
        tab = $('#SupportTabFAQs');
        tab.show();
        if (!activatedTab) {
          tab.click();
          activatedTab = true;
        }

        let faqIndex = 0;
        for (let faq of product.faqs) {
          $('#SupportTabFAQsPane .accordion').append(`
            <div class="accordion-item">
              <div class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#supportFAQ${faqIndex}">
                  ${faq.question}
                </button>
              </div>
              <div id="supportFAQ${faqIndex++}" class="accordion-collapse collapse" data-bs-parent="#supportFAQs">
                <div class="accordion-body">
                  ${faq.answer}
                </div>
              </div>
            </div>    
          `);
        }
      }
    }
    supportProduct.show();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#productDownloads").offset().top
    }, 500);
  }
};


$(document).ready(function () {
  $('#supportProducts').hide();
  $('#supportProduct').hide();
  $('#supportSearchInput').on('keypress', function (e) {
    if (e.which === 13)
      $('#supportSearchBtn').click();
  });
  const startSearchValue = ($('#supportSearchInput').val() ?? '').trim();
  if (startSearchValue !== '')
    $('#supportSearchBtn').click();
});